import React, { Component } from 'react';
import {
  Route,
  withRouter
} from "react-router-dom";
import Events from './Events';
import AccountSettings from '../controls/AccountSettings';

@withRouter
class Contents extends Component {
  render() {
    return (
    	<React.Fragment>
 			  <Route exact path="/" component={Events}/>
        <Route path="/account-settings" component={AccountSettings}/>
      </React.Fragment>
    )
  }
}

export default Contents;



// WEBPACK FOOTER //
// ./src/components/client/Contents.js